import React from "react";
import SportCode from "components/common/SportCode"
import { findArray } from 'helpers/utils'
import { isFinishedStatus, isLiveStatus, isStartListStatus } from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort';
import Flag from "components/presentation/Flag";
import Competitor from 'components/presentation/Competitor';

const TenScoreboard = ({ data, status, mirs_discipline }) => {

  const { breakPoint } = useViewport()

  let scoreboard
  let resultStatus = status

  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let homeNoc = home?.participant?.organisation?.code;
  let homeSeed = findArray(home?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value
  homeSeed = homeSeed !== undefined ? '(' + findArray(home?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value + ')' : ''

  let homeResult = home?.resultData;
  let homeWinner = home?.resultWLT;
  let homeResultType = home?.resultType;
  let homeResultIrm = home?.resultIrm
  let homeColourTeam = findArray(home?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase();

  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let awayNoc = away?.participant?.organisation?.code;
  let awaySeed = findArray(away?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value
  awaySeed = awaySeed !== undefined ? '(' + findArray(away?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value + ')' : ''

  let awayResult = away?.resultData;
  let awayWinner = away?.resultWLT;
  let awayResultType = away?.resultType;
  let awayResultIrm = away?.resultIrm
  let awayColourTeam = findArray(away?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase()

  let g1 = findArray(data?.results?.periods, { p_code: ['S1'] })
  let g2 = findArray(data?.results?.periods, { p_code: ['S2'] })
  let g3 = findArray(data?.results?.periods, { p_code: ['S3'] })

  let currentPeriod = findArray(data?.results?.extendedInfos, { ei_code: ['CURRENT_SET'] }).ei_value
  let currentServe = findArray(data?.results?.extendedInfos, { ei_code: ['SERVER'] }).ei_pos
  let currentServeCode = findArray(data?.results?.extendedInfos, { ei_code: ['SERVER'] }).ei_value
  let currentReceive = findArray(data?.results?.extendedInfos, { ei_code: ['RECEIVE'] }).ei_pos
  let currentReceiveCode = findArray(data?.results?.extendedInfos, { ei_code: ['RECEIVE'] }).ei_value
  let totalDuration = findArray(data?.results?.extendedInfos, { ei_code: ['DURATION'] }).ei_value

  let isDoubles = home?.itemType === 'T' ? true : false;

  let homeCompetitorCode = home?.itemType === 'T' ? home?.teamCode : home?.athleteCode;
  let awayCompetitorCode = away?.itemType === 'T' ? away?.teamCode : away?.athleteCode;
  let homeName = home?.participant?.name ? home?.participant?.name : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={homeCompetitorCode} />
  let awayName = away?.participant?.name ? away?.participant?.name : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={awayCompetitorCode} />

  let homePlayerOrder = home?.teamAthletes?.find(item => item?.athlete?.code === currentServeCode)?.order
  let awayPlayerOrder = away?.teamAthletes?.find(item => item?.athlete?.code === currentServeCode)?.order

  let homePlayerOrderRec = home?.teamAthletes?.find(item => item?.athlete?.code === currentReceiveCode)?.order
  let awayPlayerOrderRec = away?.teamAthletes?.find(item => item?.athlete?.code === currentReceiveCode)?.order


  scoreboard = (
    <>
      <table className="table">
        <thead>
          <tr>
            <th colSpan="4" width="50%"></th>
            <th scope="col" className="text-center">
              {isLiveStatus(resultStatus)
                ? <Label data='HeaderPoints' />
                : ''
              }
            </th>
            {currentPeriod === 'S1' && isLiveStatus(resultStatus)
              ? <th scope="col" className=" text-center score-current">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S1' /></th>
              : <th scope="col" className=" text-center ">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S1' /></th>
            }

            {currentPeriod === 'S2' && isLiveStatus(resultStatus)
              ? <th scope="col" className=" text-center score-current">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S2' /></th>
              : <th scope="col" className=" text-center">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S2' /></th>
            }
            {currentPeriod === 'S3' && isLiveStatus(resultStatus)
              ? <th scope="col" className=" text-center score-current">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S3' /></th>
              : <th scope="col" className=" text-center ">
                <ResponsiveHeaders mirs_discipline={mirs_discipline} entity='@Period' code='S3' /></th>
            }

          </tr>
        </thead>
        <tbody>
          <tr style={{ height: "80px" }}>&nbsp;
            <td className="text-start">
              <div className={`score-horizontal-uniform score-horizontal-uniform-home ${homeColourTeam ? 'uniform-color-' + homeColourTeam : 'uniform-color-silver'} `}></div>
              <div className='score-horizontal-team score-horizontal-team-home'>
                <div className={`score-horizontal-uniform-small ${homeColourTeam ? 'uniform-color-' + homeColourTeam : 'uniform-color-silver'} `}></div>
                <div className='score-horizontal-noc-flag-name'>
                  <div className='score-horizontal-noc-flag'>
                    <div className='score-horizontal-code-home'>
                      <div className='score-horizontal-code-noc'>{homeNoc}</div>
                    </div>
                    <Flag noc={homeNoc} className='score-horizontal-flag-home' />
                  </div>

                  <div className='score-horizontal-name score-horizontal-name-home d-none d-md-block'>
                    {isDoubles
                      ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={home?.teamAthletes} /></strong></>
                      : <><strong>{homeName}</strong><sup>{homeSeed}</sup></>
                    }
                  </div>
                  <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'>
                    {isDoubles
                      ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={home?.teamAthletes} /></strong></>
                      : <> <strong>{home?.participant?.shortName}</strong><sup>{homeSeed}</sup></>
                    }
                  </div>
                </div>
              </div>
            </td>

            <td>
              <div className='d-flex align-items-center'><strong>
                {isDoubles
                  ? <> {homeSeed}&nbsp; </>
                  : ''
                }
                {(homeWinner?.trim() === 'W')
                  ? <FontAwesomeIcon icon={faCheck} />
                  : homeResultType === 'IRM' || homeResultType === 'IRM_POINTS'
                    ? homeResultIrm
                    : ''
                }
              </strong></div>
            </td>
            <td>
              <div className='d-flex align-items-center'>
                {!isDoubles && homePlayerOrder !== undefined
                  ? <><img aria-hidden="true" className="ten-nav-img" src={`/assets/images/pictos/ten/ten-saque.png`} /></>
                  : ''
                }
              </div>
              {/* PARA TEAMS SERVE/RECEIVE AL JUGADOR <div className='d-flex align-items-center'>o</div><div className='d-flex align-items-center'>x</div> */}
              {isDoubles
                ? <>
                  {homePlayerOrder !== undefined ?
                    homePlayerOrder === '1'
                      ? <div className='d-flex align-items-center'><img aria-hidden="true" className="ten-nav-img" src={`/assets/images/pictos/ten/ten-saque.png`} /></div>
                      : <div className='d-flex align-items-center'>&nbsp;</div>
                    : <> {/* RECIBEN */}
                      {homePlayerOrderRec === '1'
                        ? <div className='d-flex align-items-center'></div>
                        : <div className='d-flex align-items-center'>&nbsp;</div>
                      }
                    </>
                  }
                  {homePlayerOrder !== undefined ?
                    homePlayerOrder === '2'
                      ? <div className='d-flex align-items-center'>&nbsp;</div>
                      : <div className='d-flex align-items-center'><img aria-hidden="true" className="ten-nav-img" src={`/assets/images/pictos/ten/ten-saque.png`} /></div>
                    : <> {/* RECIBEN */}
                      {homePlayerOrderRec === '2'
                        ? <div className='d-flex align-items-center'>&nbsp;</div>
                        : <div className='d-flex align-items-center'></div>
                      }
                    </>
                  }
                </>
                : ''
              }

            </td>


            <td className='text-center align-middle' >
              <div className='score-horizontal-result-number'>

                {isLiveStatus(resultStatus)
                  ? currentPeriod === 'S1'
                    ? g1?.home?.periodScore
                    : currentPeriod === 'S2'
                      ? g2?.home?.periodScore
                      : currentPeriod === 'S3'
                        ? g3?.home?.periodScore
                        : ''
                  : ''
                }
              </div>
            </td>
            {currentPeriod === 'S1' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'S2' || currentPeriod === 'S3') && g1?.home?.score > g1?.away?.score
                ? <td className='text-center align-middle score-current'><strong>{g1?.home?.score}</strong></td>
                : <td className='text-center align-middle score-current'><strong>{g1?.home?.score}</strong></td>

              : (currentPeriod === 'S2' || currentPeriod === 'S3') && g1?.home?.score > g1?.away?.score
                ? <td className='text-center align-middle'><strong>{g1?.home?.score}</strong></td>
                : <td className='text-center align-middle'><strong>{g1?.home?.score}</strong></td>
            }

            {currentPeriod === 'S2' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'S3') && g2?.home?.score > g2?.away?.score
                ? <td className='text-center align-middle score-current'><strong>{g2?.home?.score}</strong></td>
                : <td className='text-center align-middle score-current'><strong>{g2?.home?.score}</strong></td>

              : (currentPeriod === 'S3') && g2?.home?.score > g2?.away?.score
                ? <td className='text-center align-middle'><strong>{g2?.home?.score}</strong></td>
                : <td className='text-center align-middle'><strong>{g2?.home?.score}</strong></td>
            }

            {currentPeriod === 'S3' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'S3') && g3?.home?.score > g3?.away?.score
                ? <td className='text-center align-middle  score-current'><strong>{g3?.home?.score}</strong></td>
                : <td className='text-center align-middle  score-current'><strong>{g3?.home?.score}</strong></td>

              : (currentPeriod === 'S3' && isFinishedStatus(resultStatus)) && g3?.home?.score > g3?.away?.score
                ? <td className='text-center align-middle'><strong>{g3?.home?.score}</strong></td>
                : <td className='text-center align-middle'><strong>{g3?.home?.score}</strong></td>

            }


          </tr>

          <tr style={{ height: "80px" }}>&nbsp;

            <td>
              <div className={`score-horizontal-uniform score-vertical-uniform-away ${awayColourTeam ? 'uniform-color-' + awayColourTeam : 'uniform-color-silver'} `}></div>
              <div className='score-horizontal-team score-horizontal-team-home'>
                <div className={`score-horizontal-uniform-small ${awayColourTeam ? 'uniform-color-' + awayColourTeam : 'uniform-color-silver'} `}></div>
                <div className='score-horizontal-noc-flag-name'>
                  <div className='score-horizontal-noc-flag'>
                    <div className='score-horizontal-code-home'>
                      <div className='score-horizontal-code-noc'>{awayNoc}</div>
                    </div>
                    <Flag noc={awayNoc} className='score-horizontal-flag-home' />
                  </div>
                  <div className='score-horizontal-name score-horizontal-name-home d-none d-md-block'>
                    {isDoubles
                      ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={away?.teamAthletes} /></strong></>
                      : <><strong>{awayName}</strong><sup>{awaySeed}</sup></>
                    }

                  </div>
                  <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'>
                    {isDoubles
                      ? <> <strong><Competitor hidePicture={true} hideNoc={true} teamAthletes={away?.teamAthletes} /></strong></>
                      : <> <strong>{away?.participant?.shortName}</strong><sup>{awaySeed}</sup></>
                    }
                  </div>
                </div>
              </div>
            </td>

            <td>
              <div className="d-flex align-items-center"><strong>
                {isDoubles
                  ? <> {awaySeed}&nbsp; </>
                  : ''
                }
                {(awayWinner?.trim() === 'W')
                  ? <FontAwesomeIcon icon={faCheck} />
                  : awayResultType === 'IRM' || awayResultType === 'IRM_POINTS'
                    ? awayResultIrm
                    : ''
                }
              </strong></div>
            </td>
            <td>
              <div className="d-flex align-items-center">
                {!isDoubles && awayPlayerOrder !== undefined
                  ? <img aria-hidden="true" className="ten-nav-img" src={`/assets/images/pictos/ten/ten-saque.png`} />
                  : ''
                }
              </div>
              {isDoubles
                ? <>
                  {awayPlayerOrder !== undefined ?
                    awayPlayerOrder === '1'
                      ? <div className='d-flex align-items-center'><img aria-hidden="true" className="ten-nav-img" src={`/assets/images/pictos/ten/ten-saque.png`} /></div>
                      : <div className='d-flex align-items-center'>&nbsp;</div>
                    : <> {/* RECIBEN */}
                      {awayPlayerOrderRec === '1'
                        ? <div className='d-flex align-items-center'>*</div>
                        : <div className='d-flex align-items-center'>&nbsp;</div>
                      }
                    </>}
                  {awayPlayerOrder !== undefined ?
                    awayPlayerOrder === '2'
                      ? <div className='d-flex align-items-center'>&nbsp;</div>
                      : <div className='d-flex align-items-center'><img aria-hidden="true" className="ten-nav-img" src={`/assets/images/pictos/ten/ten-saque.png`} /></div>
                    : <> {/* RECIBEN */}
                      {awayPlayerOrderRec === '2'
                        ? <div className='d-flex align-items-center'>*</div>
                        : <div className='d-flex align-items-center'>&nbsp;</div>
                      }
                    </>}
                </>
                : ''
              }
            </td>

            <td className="text-center align-middle" >
              <div className='score-horizontal-result-number'>

                {isLiveStatus(resultStatus)
                  ? currentPeriod === 'S1'
                    ? g1?.away?.periodScore
                    : currentPeriod === 'S2'
                      ? g2?.away?.periodScore
                      : currentPeriod === 'S3'
                        ? g3?.away?.periodScore
                        : ''
                  : ''
                }
              </div>
            </td>
            {currentPeriod === 'S1' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'S2' || currentPeriod === 'S3') && g1?.away?.score > g1?.home?.score
                ? <td className="text-center align-middle score-current"><strong>{g1?.away?.score}</strong></td>
                : <td className="text-center align-middle score-current"><strong>{g1?.away?.score}</strong></td>

              : (currentPeriod === 'S2' || currentPeriod === 'S3') && g1?.away?.score > g1?.home?.score
                ? <td className="text-center align-middle "><strong>{g1?.away?.score}</strong></td>
                : <td className="text-center align-middle"><strong>{g1?.away?.score}</strong></td>
            }

            {currentPeriod === 'S2' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'S3') && g2?.away?.score > g2?.home?.score
                ? <td className="text-center align-middle score-current"><strong>{g2?.away?.score}</strong></td>
                : <td className="text-center align-middle score-current"><strong>{g2?.away?.score}</strong></td>

              : (currentPeriod === 'S3') && g2?.away?.score > g2?.home?.score
                ? <td className="text-center align-middle"><strong>{g2?.away?.score}</strong></td>
                : <td className="text-center align-middle"><strong>{g2?.away?.score}</strong></td>
            }

            {currentPeriod === 'S3' && isLiveStatus(resultStatus)
              ? (currentPeriod === 'S3') && g3?.away?.score > g3?.home?.score
                ? <td className="text-center align-middle  score-current"><strong>{g3?.away?.score}</strong></td>
                : <td className="text-center align-middle  score-current"><strong>{g3?.away?.score}</strong></td>

              : (currentPeriod === 'S3' && isFinishedStatus(resultStatus)) && g3?.away?.score > g3?.home?.score
                ? <td className="text-center align-middle"><strong>{g3?.away?.score}</strong></td>
                : <td className="text-center align-middle"><strong>{g3?.away?.score}</strong></td>

            }

          </tr>

          <tr style={{ height: "20px" }}>
            <td className="text-end align-middle" colSpan="4">
              {!isStartListStatus(resultStatus)
                ? <><Label data='HeaderMatchDuration' /> :</>
                : ''
              }
            </td>

            <td className="text-center align-middle">{totalDuration}{totalDuration > 0 ? <Label data='HeaderMinute' /> : ''}</td>

            {currentPeriod === 'S1' && isLiveStatus(resultStatus)
              ? <td className="text-center align-middle score-current">{g1?.p_duration}{g1?.p_duration > 0 ? <Label data='HeaderMinute' /> : ''}</td>
              : <td className="text-center align-middle">{g1?.p_duration}{g1?.p_duration > 0 ? <Label data='HeaderMinute' /> : ''}</td>
            }
            {currentPeriod === 'S2' && isLiveStatus(resultStatus)
              ? <td className="text-center align-middle score-current">{g2?.p_duration}{g2?.p_duration > 0 ? <Label data='HeaderMinute' /> : ''}</td>
              : <td className="text-center align-middle">{g2?.p_duration}{g2?.p_duration > 0 ? <Label data='HeaderMinute' /> : ''}</td>
            }
            {currentPeriod === 'S3' && isLiveStatus(resultStatus)
              ? <td className="text-center align-middle score-current">{g3?.p_duration}{g3?.p_duration > 0 ? <Label data='HeaderMinute' /> : ''}</td>
              : <td className="text-center align-middle">{g3?.p_duration}{g3?.p_duration > 0 ? <Label data='HeaderMinute' /> : ''}</td>
            }
          </tr>
        </tbody>
      </table>
    </>
  )

  return scoreboard
}


const ResponsiveHeaders = ({ mirs_discipline, entity, code }) => {
  const { breakPoint } = useViewport()
  if (breakPoint === "sm" || breakPoint === "xs") {
    return (
      <>{code}</>

    )
  }
  else {
    return (
      <>
        <SportCode discipline={mirs_discipline} entity={entity} code={code} />
      </>
    )
  }

}

export default TenScoreboard